import * as types from "./followUpActionTypes";
import FollowUpsApi from "./followUpApi";

export function setFollowUp(count) {
	return {
		type: types.SET_FOLLOW_UP_CHECKBOXES,
		count: FollowUpsApi.setFollowUp(count)
	};
}


// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/followUpActions.js